import { Button } from "@omni/ui/components/Button/button.component";
import "./storeDirectionsResult.scss";

type StoreDirecitonsResultSkeletonProps = {
    onChangeOriginClick: () => void;
};

export const StoreDirecitonsResultSkeleton = ({
    onChangeOriginClick
}: StoreDirecitonsResultSkeletonProps) => {
    return (
        <>
            <div
                className={"store-directions-result__waypoints"}
                onClick={onChangeOriginClick}
            >
                <p className={"store-directions-result__waypoints__waypoint"}>
                    <span className="store-directions-result__loader" />
                </p>
                <i
                    className={
                        "store-directions-result__waypoints__direction las la-lg la-arrow-right"
                    }
                />
                <p className={"store-directions-result__waypoints__waypoint"}>
                    <span className="store-directions-result__loader" />
                </p>
            </div>
            <p className={"store-directions-result__distance"}>
                Afstand van je route
            </p>
            <Button
                type={"button"}
                color={"link"}
                onClick={onChangeOriginClick}
                className={"store-directions-result__change-origin"}
            >
                <i className={"las la-angle-left"} />
                Kies en ander vertrekpunt
            </Button>
        </>
    );
};
